import { useEffect } from 'react';
import 'bootstrap/js/dist/modal'
import CalendlyInit from '../../modules/CalendlyInit'

const CalendlyModal = () => {
  useEffect(() => {
    CalendlyInit.openCalendly(
      'calendy-results-block',
      'https://calendly.com/accesseu/schedule-a-free-consultation?hide_event_type_details=1&hide_gdpr_banner=1'
    );
  }, []);

  return (
    <>
      <div className="modal modal-xl fade modal-results-button-calendly" id="modal-results-button-calendly" aria-labelledby="section-modal-results-button-calendly-label">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0">
              {/* <h2 className="modal-title fs-3 p-0 m-0 border-0" id="section-modal-results-button-calendly-label">Let's turn your ADA scan into actionable solutions:</h2> */}
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body text-start p-4 px-xl-7 pb-xl-7" style={{ minHeight: '300px' }}>
              <div id="calendy-results-block" className="calendy-results-block" dataresize="true" style={{ margin: 0, padding: 0 }}></div>
              {/* Required for WP Rocket */}
              <div className="row mb-5 col-xl-6 mb-xl-0 text-secondary w-100 d-flex flex-column alert alert-info align-items-center loader-container mt-5 justify-content-between result-container mb-6 fs-4 score-fill position-relative number position-absolute h-100 mb-0 fs-5 improvement-list ps-0 d-block improvement-title border-bottom pb-4 fw-medium arrow-icon improvement-description d-none loader modal-backdrop"></div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
}

export default CalendlyModal;
